import React, { useState } from 'react';
interface PricingOption {
  id: string;
  emoji: string;
  title: string;
  description: string;
  idealFor: string;
  originalPrice: string;
  price: string;
  ctaText: string;
  ctaHref: string;
  isFeatured?: boolean;
}
const options: PricingOption[] = [{
  id: 'megapack',
  emoji: '📘',
  title: 'MEGAPACK PILATES LISTO',
  description: '6 Tomos + 6 Bonos',
  idealFor: 'Todo el año resuelto',
  originalPrice: '$89.000',
  price: '$19.990 ARS',
  ctaText: '→ QUIERO MI MEGAPACK',
  ctaHref: 'https://www.verticedigital.store/cart/52918911926383:1'
}, {
  id: 'elite',
  emoji: '🏆',
  title: 'MEGAPACK + ESPECIALISTA ⭐',
  description: '6 Tomos + 6 Bonos + Manual de Posturología Experta',
  idealFor: 'Especialistas que quieren cobrar más',
  originalPrice: '$119.000',
  price: '$27.990 ARS',
  ctaText: '→ QUIERO EL MEGAPACK + ESPECIALISTA',
  ctaHref: 'https://www.verticedigital.store/cart/52918915858543:1',
  isFeatured: true
}];
export function PricingSection() {
  const [selected, setSelected] = useState('elite');
  const selectedOption = options.find(o => o.id === selected)!;
  return <section id="pricing" className="w-full bg-[#111111] py-10 sm:py-16 px-4" data-id="element-244">
      <div className="max-w-xl mx-auto" data-id="element-245">
        {/* Header */}
        <h2 className="text-2xl sm:text-4xl font-black text-white text-center mb-1 sm:mb-3" data-id="element-246">
          ELEGÍ TU <span className="text-[#A855F7]" data-id="element-247">MEGAPACK</span>
        </h2>

        {/* Options */}
        <div className="space-y-3 sm:space-y-4 mb-5 sm:mb-8 mt-8" data-id="element-248">
          {options.map(option => {
          const isSelected = selected === option.id;
          const isFeatured = option.isFeatured;
          return <button key={option.id} onClick={() => setSelected(option.id)} className={`w-full text-left rounded-xl sm:rounded-2xl p-4 sm:p-6 transition-all ${isFeatured && isSelected ? 'border-2 border-[#A855F7] bg-[#0d0818] shadow-[0_0_30px_rgba(168,85,247,0.15)]' : isFeatured ? 'border-2 border-[#A855F7]/50 bg-[#0d0818]' : isSelected ? 'border-2 border-[#A855F7] bg-[#0a0a0a]' : 'border border-white/10 bg-[#0a0a0a]'}`} data-id="element-249">
                <div className="flex items-center gap-3 sm:gap-4" data-id="element-250">
                  {/* Radio */}
                  <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${isSelected ? 'border-[#A855F7]' : 'border-white/30'}`} data-id="element-251">
                    {isSelected && <div className="w-3 h-3 rounded-full bg-[#A855F7]" data-id="element-252" />}
                  </div>

                  {/* Info */}
                  <div className="flex-1 min-w-0" data-id="element-253">
                    <div className="flex items-center gap-2 flex-wrap" data-id="element-254">
                      <span className="text-lg" data-id="element-255">{option.emoji}</span>
                      <span className="text-white font-black text-base sm:text-lg" data-id="element-256">
                        {option.title}
                      </span>
                    </div>

                    <p className="text-gray-400 text-sm mt-1" data-id="element-257">
                      {option.description}
                    </p>
                    <p className="text-[#A855F7] text-xs font-bold mt-1" data-id="element-258">
                      Ideal para: {option.idealFor}
                    </p>
                  </div>

                  {/* Price */}
                  <div className="text-right flex-shrink-0" data-id="element-259">
                    <div className="text-gray-400 line-through text-xs sm:text-sm" data-id="element-260">
                      {option.originalPrice}
                    </div>
                    <div className={`font-black text-2xl sm:text-3xl ${isFeatured ? 'text-[#A855F7]' : 'text-white'}`} data-id="element-261">
                      {option.price}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* CTA Button */}
        <a href={selectedOption.ctaHref} className="btn-purple-pulse block w-full text-center bg-[#A855F7] font-black text-base sm:text-xl py-4 sm:py-5 rounded-xl sm:rounded-2xl hover:bg-[#C084FC] transition-colors text-[#FFFFFF]" data-id="element-262">
          {selectedOption.ctaText}
        </a>
      </div>
    </section>;
}